module.exports = __webpack_public_path__ + "assets/img/Edito_Olivier-Lecler_cover.f3fea03e-ps.jpg";